// extracted by mini-css-extract-plugin
export var modal = "_bq-0";